import { useHistory } from "react-router-dom";
import { AD_ID_PARAM, INBOX_TYPE_PARAM, USER_ID_PARAM } from "../constants/constants";

export const useChatListFilters = (loadChats: (params: any) => void) => {
  const history = useHistory()

  
  const onInboxFilterChange = (inboxFilterType) => {
    loadChats({ inboxType: inboxFilterType })
    const newPath = inboxFilterType != null ? `/poruke?${INBOX_TYPE_PARAM}=${inboxFilterType}` : "/poruke"
    history.push(newPath)
  }

  const onUserFilterChange = (userId) => {
    loadChats({ userId })
    const newPath = userId ? `/poruke?${USER_ID_PARAM}=${userId}` : "/poruke"
    history.push(newPath)
  }

  const onAdFilterChange = (adId) => {
    loadChats({ adId })
    const newPath = adId ? `/poruke?${AD_ID_PARAM}=${adId}` : "/poruke"
    history.push(newPath)
  }


  return {
    onInboxFilterChange,
    onUserFilterChange,
    onAdFilterChange
  }

}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/hooks/useChatListFilters.ts